// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Lhko","content":"styles_content__zROWq","tableWrap":"styles_tableWrap__nQbss"};